import axios from "axios";

const url = process.env.REACT_APP_API_URL;

export const mail = (message) => axios.post(url + `/api/contact`, { message });
